export enum PriceLevel {
  Free = 'free',
  Inexpensive = 'inexpensive',
  Moderate = 'moderate',
  Expensive = 'expensive',
  VeryExpensive = 'very-expensive',
}

const PRICE_LEVEL_BY_VALUE: ReadonlyMap<string, PriceLevel> = new Map(
  Object.values(PriceLevel).map((level) => [level, level]),
);

export const parsePriceLevel = (value: string): PriceLevel | null => PRICE_LEVEL_BY_VALUE.get(value) ?? null;
